function loaderMarkup() {
  return `<span class="loader is-hidden"></span>`;
}
export default loaderMarkup;
